/* 0.47.17 - --page-w: the page's real width, without the scrollbar.
 *
 * html reserves the scrollbar's room (global.css: scrollbar-gutter:
 * stable, overflow-y: scroll), and 100vw INCLUDES that room. A
 * full-width band drawn with 100vw was therefore half a scrollbar too
 * far left (about 8px on Windows), so its content did not line up with
 * the header or with a Layer kept inside the columns. The body's own
 * width is the page's width; it is kept on the page root as --page-w,
 * and global.css draws full-width bands with it (100vw until it is
 * known). Updated when the window or the page changes size. */
export function watchPageWidth() {
  if (typeof document === 'undefined' || !document.body) return;
  const root = document.documentElement;
  let last = -1;
  const set = () => {
    const w = document.body.clientWidth;
    if (w > 0 && w !== last) {
      last = w;
      root.style.setProperty('--page-w', `${w}px`);
    }
  };
  set();
  window.addEventListener('resize', set);
  if (typeof ResizeObserver !== 'undefined') new ResizeObserver(set).observe(document.body);
}
